/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: v8UWVOLwo7Y3
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "../o_21_p_team_2_0_0_prod/PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "../o_21_p_team_2_0_0_prod/plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicTeammateCard.module.css"; // plasmic-import: v8UWVOLwo7Y3/css

createPlasmicElementProxy;

export const PlasmicTeammateCard__VariantProps = new Array("isPlaceholder");

export const PlasmicTeammateCard__ArgProps = new Array("mateName", "photo");

const $$ = {};

function PlasmicTeammateCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          mateName: "MATE"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isPlaceholder",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.isPlaceholder
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_cGVJnrZBpZGCmuty7FxDYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootisPlaceholder]: hasVariant(
            $state,
            "isPlaceholder",
            "isPlaceholder"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"photoSlot"}
        data-plasmic-override={overrides.photoSlot}
        className={classNames("all", sty.photoSlot, {
          [sty.photoSlotisPlaceholder]: hasVariant(
            $state,
            "isPlaceholder",
            "isPlaceholder"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.photo
        })}
      </div>
      <div
        data-plasmic-name={"name"}
        data-plasmic-override={overrides.name}
        className={classNames("all", sty.name)}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames("all", "__wab_text", sty.text, {
            [sty.textisPlaceholder]: hasVariant(
              $state,
              "isPlaceholder",
              "isPlaceholder"
            )
          })}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.mateName;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "MAT";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "photoSlot", "name", "text"],
  photoSlot: ["photoSlot"],
  name: ["name", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTeammateCard__ArgProps,
          internalVariantPropNames: PlasmicTeammateCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTeammateCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTeammateCard";
  } else {
    func.displayName = `PlasmicTeammateCard.${nodeName}`;
  }
  return func;
}

export const PlasmicTeammateCard = Object.assign(
  // Top-level PlasmicTeammateCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    photoSlot: makeNodeComponent("photoSlot"),
    _name: makeNodeComponent("name"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicTeammateCard
    internalVariantProps: PlasmicTeammateCard__VariantProps,
    internalArgProps: PlasmicTeammateCard__ArgProps
  }
);

export default PlasmicTeammateCard;
/* prettier-ignore-end */
